/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit OnboardingUnderline/view.blocks to change it.
import React from 'react'
import sourcePng from "./source.png"
import styles from './view.module.css'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function OnboardingUnderline({
  children,
  viewPath = "/DesignSystem/Images/OnboardingUnderline",
  alignSelf = "auto",
  backgroundColor = "transparent",
  borderBottomLeftRadius = 0,
  borderBottomRightRadius = 0,
  borderTopLeftRadius = 0,
  borderTopRightRadius = 0,
  height = 30,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  marginTop = 0,
  source = sourcePng,
  width = 150
  
}) {
  return (<React.Fragment
>
<img
  data-testid="OnboardingUnderline.Image"
  data-view-path={viewPath}
 alt={""}
 src={source}
 style={{'--as-1-iOjse': alignSelf,'--bc-2-iOjse': backgroundColor,'--bblr-3-iOjse': typeof borderBottomLeftRadius === 'number' ? `${borderBottomLeftRadius}px` : borderBottomLeftRadius,'--bbrr-4-iOjse': typeof borderBottomRightRadius === 'number' ? `${borderBottomRightRadius}px` : borderBottomRightRadius,'--btlr-5-iOjse': typeof borderTopLeftRadius === 'number' ? `${borderTopLeftRadius}px` : borderTopLeftRadius,'--btrr-6-iOjse': typeof borderTopRightRadius === 'number' ? `${borderTopRightRadius}px` : borderTopRightRadius,'--h-7-iOjse': typeof height === 'number' ? `${height}px` : height,'--mb-8-iOjse': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-9-iOjse': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-10-iOjse': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--mt-11-iOjse': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--w-12-iOjse': typeof width === 'number' ? `${width}px` : width}}
 className={`views-block ${styles.Image}`}
/>
{children}
</React.Fragment>)
}